module.exports = __webpack_public_path__ + "static/media/searchop.6de47696.svg";